import { render, staticRenderFns } from "./solutionsTab2.vue?vue&type=template&id=528fb3c7&"
import script from "./solutionsTab2.vue?vue&type=script&lang=js&"
export * from "./solutionsTab2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports